import { render, staticRenderFns } from "./studioData.vue?vue&type=template&id=2b99fc82&scoped=true"
import script from "./studioData.vue?vue&type=script&lang=js"
export * from "./studioData.vue?vue&type=script&lang=js"
import style0 from "./studioData.vue?vue&type=style&index=0&id=2b99fc82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b99fc82",
  null
  
)

export default component.exports